export default __webpack_public_path__ + "static/media/slider-img5.9cafaa96.jpg";